import React, { useContext } from 'react';
import styled from 'styled-components';

import { Flex } from '../atom/Layout';
import { OnlyInput } from '../atom/Input';
import { Button } from '../atom/Button';
import Icon from '../atom/Icon';

import { useCopy } from '../../../Hooks/useCopy';
import { useShare } from '../../../Hooks/useShare';
import ModalContext from '../../../modules/contexts/Modalcontext';
import {
  FACEBOOK_LOGO,
  KAKAO_STORY_LOGO,
  KAKAO_TALK_LOGO,
  NAVER_BAND_LOGO,
  NAVER_LOGO,
  TWITTER_LOGO,
} from '../../../lib/image/SNSLogoImages';

export const SocialShareIconButton = ({
  params = { url: '', title: '', text: '', imageUrl: '' },
  ...props
}) => {
  const {
    actions: { onModal },
  } = useContext(ModalContext);

  return (
    <Icon
      iconName="share"
      size={16}
      onClick={() =>
        onModal({
          title: '링크 공유하기',
          content: <SocialShareButtonBox params={params} {...props} />,
        })
      }
    />
  );
};

export const SocialShareButtonBox = ({
  params = { url: '', title: '', text: '', imageUrl: '' },
  ...props
}) => {
  const { url } = params;
  return (
    <Flex column width="100%">
      <Grid>
        <SnsShareButton params={params} {...props} />
      </Grid>
      <CopyToClipBoardButtonWithLink url={url} />
    </Flex>
  );
};

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(2, 1fr);
  gap: 0.938rem 1.625rem;
  width: 100%;
  padding: 1.5rem 0;
`;

export const SnsShareButton = ({ params, ...props }) => {
  const { shareSNS } = useShare({ ...params, ...props });

  return SNS_LOGO_LIST.map((item) => (
    <img
      onClick={() => shareSNS(item.name)}
      key={item.id}
      src={item.logo}
      alt={item.id}
      style={{
        width: '3rem',
        height: '3rem',
        cursor: 'pointer',
      }}
    />
  ));
};

const SNS_LOGO_LIST = [
  { id: 'facebook-share-button', name: 'facebook', logo: FACEBOOK_LOGO },
  { id: 'naver-share-button', name: 'naver', logo: NAVER_LOGO },
  {
    id: 'naverBand-share-button',
    name: 'naverBand',
    logo: NAVER_BAND_LOGO,
  },
  {
    id: 'twitter-share-button',
    name: 'twitter',
    logo: TWITTER_LOGO,
  },
  {
    id: 'kakao-link-btn',
    name: 'kakaoTalk',
    logo: KAKAO_TALK_LOGO,
  },
  {
    id: 'kakaostory-share-button',
    name: 'kakaoStory',
    logo: KAKAO_STORY_LOGO,
  },
];

export const CopyToClipBoardButtonWithLink = ({ url }) => {
  const { onCopyToClipboard } = useCopy();
  return (
    <Flex width="100%">
      <OnlyInput value={url} flex={3} readOnly />
      <Button
        color="pinkishGrey"
        onClick={() =>
          onCopyToClipboard({
            text: url,
            message: '클립보드에 링크가 복사되었습니다.',
            error:
              '링크 복사에 실패하였습니다.\n\n링크 드래그 후 "복사"버튼을 누르면 클립보드에 코드가 복사됩니다.',
          })
        }
        style={{ flex: 1, marginLeft: '0.625rem' }}
      >
        복사
      </Button>
    </Flex>
  );
};
